var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:( _obj = {
    'group-button': true
  }, _obj[("group-button--" + _vm.align)] = true, _obj )},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }